import React from "react";

function Widget({ title, children, className }) {
  return (
    <div className={`widget-item ` + className}>
      <h4 className="widget-title">{title}</h4>
      <div className="widget-body">{children}</div>
    </div>
  );
}

export default Widget;
